import ReportsGroupBody from './ReportsGroupBody';

export default ReportsGroupBody;
